export enum ExpireInMinutesEnum {
  TWO_DAYS = "2880",
  DAY = "1440",
  TWELVE_HOURS = "720",
  SIX_HOURS = "360",
  TWO_HOURS = "120",
  HOUR = "60",
}
